import type { Insight } from '@/types/insights';

export type InsightGenerationFailure = 'initial' | 'regeneration' | null;

export const resolveInsightGenerationFailure = (
  data: Insight | undefined,
  isRegenerating: boolean,
): InsightGenerationFailure => {
  if (isRegenerating || data?.latest_attempt.generation_status !== 'error') {
    return null;
  }
  return data.generation_status === 'processed' ? 'regeneration' : 'initial';
};
